import http from "@/middleware";

class EventApi {
    async getEventsByThingsIds(ids) {
        let result = await http.post('/api/event/byThings', { thingsIds: ids })
        return result.data
    }
}

export default new EventApi();